import { constants } from '../../../constants/Constants';
import withLazyLoad from 'hooks/withLazyLoad';

// AIQ-specific lazy-loaded components
// const LazyAIQOverview = withLazyLoad(
//   () => import('../../../containers/OverView/AIQOverview'),
//   true
// );
const LazyAIQUserEngagement = withLazyLoad(
  () => import('../../../containers/UserBehaviorEngagement/AIQ'),
  true
);
const LazyAIQSuccessReport = withLazyLoad(
  () => import('../../../containers/SuccessReport'),
  true
);

// AIQ-specific tab identifiers
export const TAB_AIQ_OVERVIEW = 'aiqOverview';
export const TAB_AIQ_USER_ADOPTION = 'aiqUserAdoption';
export const TAB_AIQ_SUCCESS_REPORT = 'aiqSuccessReport';

// AIQ tab configurations
export const AIQ_TABS = {
  [TAB_AIQ_USER_ADOPTION]: {
    id: TAB_AIQ_USER_ADOPTION,
    label: 'User Adoption',
    component: LazyAIQUserEngagement,
  },
  [TAB_AIQ_SUCCESS_REPORT]: {
    id: TAB_AIQ_SUCCESS_REPORT,
    label: 'Success Report',
    component: LazyAIQSuccessReport,
  },
};

// AIQ product registry configuration
export const AIQ_REGISTRY = {
  [constants.products.AIQ]: [
    { tab: AIQ_TABS[TAB_AIQ_SUCCESS_REPORT] },
    { tab: AIQ_TABS[TAB_AIQ_USER_ADOPTION] },
  ],
};

// Export all AIQ tab identifiers for external use
export const AIQ_TAB_IDENTIFIERS = {
  TAB_AIQ_SUCCESS_REPORT,
  TAB_AIQ_USER_ADOPTION,
};
